// import plusmp3 from "../../../audio/+.mp3";
// import minusmp3 from "../../../audio/-.wav";

import { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { handleBet } from "../../../redux/actions/postActions";
import useSound from "use-sound";

import divideSF from "./audio/divide.mp3";
import multiplySF from "./audio/multiply.mp3";

export default function useBetOperations(
  MyBet,
  inredux,
  sound,
  handleNotification,
  toFix,
  minBet,
  maxBet,
  currency,
  sdad = 1
) {
  const [volume] = useState(true);
  if (MyBet) MyBet = (+MyBet).toFixed(toFix);
  const [useBet, setbet] = useState(MyBet);

  const [multiplySFX] = useSound(multiplySF, { volume });
  const [divideSFX] = useSound(divideSF, { volume });
  const mult = 2;
  const divd = 1 / 2;
  const [min, setmin] = useState(minBet);
  const [max, setmax] = useState(maxBet);
  const [first, setfirst] = useState("");
  const [isHold, setisHold] = useState(false);
  const [trigger, settrigger] = useState("");

  const diff = (1 / Math.pow(10, toFix))
  useEffect(() => {
    setmin(minBet);
  }, [minBet]);
  useEffect(() => {
    setmax(maxBet);
  }, [maxBet]);
  useEffect(() => {
    setbet(MyBet);
  }, [MyBet]);

  const plus = () => {
    setbet((b) =>
      +b + +diff > max
        ? (() => {
          handleNotification(
            "Maximum bet limit is " + max.toFixed(toFix) + " " + currency
          );
          return max.toFixed(toFix);
        })()
        : (() => {
          if (sound) multiplySFX();
          return (+b + +diff).toFixed(toFix);
        })()
    );
  };
  const minus = () => {
    setbet((b) =>
      b - diff < min
        ? (() => {
          handleNotification(
            "Minimum bet limit is " + min.toFixed(toFix) + " " + currency
          );
          return min.toFixed(toFix);
        })()
        : (() => {
          if (sound) divideSFX();
          return (b - diff).toFixed(toFix);
        })()
    );
  };
  const multiply = (n) => {
    setbet((b) =>
      b * (n || mult) > max
        ? (() => {
          handleNotification(
            "Maximum bet limit is " + max.toFixed(toFix) + " " + currency
          );
          return max.toFixed(toFix);
        })()
        : (() => {
          if (sound) multiplySFX();
          return (b * (n || mult)).toFixed(toFix);
        })()
    );
  };
  const divide = () => {
    setbet((b) =>
      b * divd < min
        ? (() => {
          handleNotification(
            "Minimum bet limit is " + min.toFixed(toFix) + " " + currency
          );
          return min.toFixed(toFix);
        })()
        : (() => {
          if (sound) divideSFX();
          return (b * divd).toFixed(toFix);
        })()
    );
  };
  useEffect(() => {
    let interval = null;
    let mytimeout = null;
    if (isHold) {
      if (trigger === "acceleratablePlus") {
        mytimeout = setTimeout(() => {
          interval = setInterval(() => {
            // let last = Date.now();
            // let d = last - first;
            let df = diff;
            setbet((b) =>
              +b + +df > max
                ? (() => {
                  handleNotification(
                    "Maximum bet limit is " +
                    max.toFixed(toFix) +
                    " " +
                    currency
                  );
                  return max.toFixed(toFix);
                })()
                : (() => {
                  if (sound) multiplySFX();
                  return (+b + +df).toFixed(toFix);
                })()
            );
          }, 80);
        }, 400);
      } else {
        mytimeout = setTimeout(() => {
          interval = setInterval(() => {
            // let last = Date.now();
            // let d = last - first;
            let df = diff;
            setbet((b) =>
              b - +df < min
                ? (() => {
                  handleNotification(
                    "Minimum bet limit is " +
                    min.toFixed(toFix) +
                    " " +
                    currency
                  );
                  return min.toFixed(toFix);
                })()
                : (() => {
                  if (sound) divideSFX();
                  return (b - +df).toFixed(toFix);
                })()
            );
          }, 80);
        }, 400);
      }
    }
    return () => {
      clearInterval(interval);
      clearTimeout(mytimeout);
    };
  }, [
    isHold,
    first,
    trigger,
    handleNotification,
    toFix,
    max,
    min,
    currency,
    divideSFX,
    multiplySFX,
    sound,
    diff,
  ]);

  const handleButtonPress = (e) => {
    setfirst(Date.now());
    settrigger(e);
    setisHold(true);
  };

  const handleButtonRelease = () => setisHold(false);

  return [
    useBet,
    plus,
    minus,
    multiply,
    divide,
    handleButtonPress,
    handleButtonRelease,
  ];
}
